import { render, staticRenderFns } from "./SocialBill.vue?vue&type=template&id=6ea24b13"
import script from "./SocialBill.vue?vue&type=script&lang=js"
export * from "./SocialBill.vue?vue&type=script&lang=js"
import style0 from "./SocialBill.vue?vue&type=style&index=0&id=6ea24b13&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports